# Practical Tips & Workflows

## Getting Started

Start with Ollama or LM Studio w/ running server + your editor integration (Continue.dev, Cline, Cursor) or terminal UI (opencode)

Use specific models for specific tasks — coding vs general vs reasoning

## Best Practices

Keep cloud AI for complex tasks, use local for iteration and experimentation

Context is king — paste relevant code, be specific in your prompts

## Integration & Automation

Schedule background tasks with cron for overnight processing

Use n8n for visual workflow automation with local LLM nodes

Connect via APIs to Home Assistant, Nextcloud, or your local services

Use local vector databases (ChromaDB, Qdrant) for semantic search